import Marquee from "react-fast-marquee";
import { Factory, HeartPulse, GraduationCap, Building2, LandPlot, Zap } from "lucide-react";

const items = [
  { icon: Factory, label: "Manufacturing" },
  { icon: HeartPulse, label: "Healthcare" },
  { icon: GraduationCap, label: "Education" },
  { icon: Building2, label: "Smart Buildings" },
  { icon: LandPlot, label: "Smart Cities" },
  { icon: Zap, label: "Energy & Utilities" },
];

export default function TrustedBy() {
  return (
    <section data-testid="trusted-by-section" className="py-16 border-y border-white/5 bg-[#0B0F19]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="text-center text-xs uppercase tracking-[0.3em] text-slate-400 mb-8">
          Trusted across industries
        </p>
        <div className="marquee-fade">
          <Marquee gradient={false} speed={40} pauseOnHover>
            {[...items, ...items].map((it, i) => {
              const Icon = it.icon;
              return (
                <div
                  key={i}
                  className="mx-8 sm:mx-12 flex items-center gap-3 text-slate-300 hover:text-white transition"
                >
                  <Icon className="w-5 h-5 text-cyan-400" />
                  <span className="font-heading font-semibold tracking-wide text-base sm:text-lg whitespace-nowrap">
                    {it.label}
                  </span>
                </div>
              );
            })}
          </Marquee>
        </div>
      </div>
    </section>
  );
}
